<!--
  - Author: Raul Perusquia <raul@inikoo.com>
  - Created: Fri, 09 Feb 2024 10:30:07 Malaysia Time, Kuala Lumpur, Malaysia
  - Copyright (c) 2024, Raul A Perusquia Flores
  -->

<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import { useForm } from '@inertiajs/vue3'
// import { trans } from 'laravel-vue-i18n'
// import ValidationErrors from '@/Components/ValidationErrors.vue'
import PureInput from '@/Components/Pure/PureInput.vue'
import Button from '@/Components/Utils/Button.vue'
import Layout from '@/Layouts/AuthLayout.vue'

defineOptions({ layout: Layout })

const isPasswordSame = ref(false)
const repeatPassword = ref('')

const formReset = useForm({
    password: '',
    email: route().params?.email,
    token: route().params?.token,
})

const submitResetPassword = () => {
    console.log('ewew', route().params.token)
    if (route().params?.token) {
        formReset.patch(route('retina.reset-password.email.update'), {})
    } else {
        formReset.patch(route('retina.reset-password.update'), {})
    }
}


watchEffect(() => {
    formReset.password == repeatPassword.value ? isPasswordSame.value = true : isPasswordSame.value = false
})
</script>

<template>

    <div class="space-y-4 text-gray-600">

        <form class="space-y-8" @submit.prevent="submitResetPassword">
            <div class="text-center font-semibold text-xl">
                The Administrator ask you to reset password"
            </div>

            <div class="flex flex-col gap-y-4">
                <div class="">
                    <label for="password">New Password</label>
                    <PureInput v-model="formReset.password" type="password" inputName="password"
                        placeholder="Enter new password" />
                    <div v-if="formReset.errors.password">{{ formReset.errors.password }}</div>
                </div>

                <div class="">
                    <label for="repeatPassword">Repeat New Password</label>
                    <PureInput v-model="repeatPassword" type="password" inputName="repeatPassword"
                        placeholder="Repeat your new password" />
                    <div v-if="!isPasswordSame && repeatPassword && formReset.password"
                        class="text-red-500 mt-1 text-sm">Password is not match</div>
                </div>
            </div>

            <div class="flex justify-center">
                <Button :style="'primary'" :disabled="!isPasswordSame || formReset.password.length == 0"
                    :key="formReset.password + repeatPassword" :label="'Reset Password'" @click="submitResetPassword"
                    class="" />
            </div>
        </form>
    </div>
    <ValidationErrors />
</template>
